import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  icon: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 4,
    color: "#fff",
    fontSize: 15,
    position: "relative",
    width: 18,
    height: 16,
    margin: "0 2px",
  },
}))

export default styles
